import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withQuery } from '../../../hoc/withGraphql';
import Loader from '../../../components/Common/Loader/Loader';
import EditPartnerForm from '../../../components/SiteAdmin/EditPartnerForm/EditPartnerForm';
import NotFound from '../../../components/NotFound/NotFound';
import { censorEmail, decode, censorPhone, censorWord } from '../../../helpers/queryEncryption';
import { demoRestrictionEncode } from '../../../actions/demoRestriction';
import getUser from './getUser.graphql';
import messages from '../../../locale/messages';

import { getUserCategoryQuery } from '../../../lib/graphql';

export class EditPartner extends Component {
    static propTypes = {
        id: PropTypes.number.isRequired,
    };

    static defaultProps = {
        data: {
            loading: true
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            isRestrict: false,
        };
    }

    async componentDidMount() {
        const { demoRestrictionEncode } = this.props;
        const isRestrict = await demoRestrictionEncode({});
        this.setState({ isRestrict });
    }

    render() {
        const { data: { loading, getUser }, userCategoryDetails } = this.props;
        const { formatMessage } = this.props.intl;
        const { isRestrict } = this.state;
        const userCategoryLoding = userCategoryDetails.loading;

        let initialValues = {};

        if (!loading && getUser && getUser?.status === 200) {
            initialValues = {
                id: getUser?.result?.id,
                firstName: isRestrict ? censorWord(decode(getUser?.result?.profile?.encryptFirstName)) : decode(getUser?.result?.profile?.encryptFirstName),
                lastName: isRestrict ? censorWord(decode(getUser?.result?.profile?.encryptLastName)) : decode(getUser?.result?.profile?.encryptLastName),
                email: isRestrict ? censorEmail(decode(getUser?.result?.encryptEmail)) : decode(getUser?.result?.encryptEmail),
                phoneNumber: isRestrict ? censorPhone(decode(getUser?.result?.encryptPhoneNumber)) : decode(getUser?.result?.encryptPhoneNumber),
                phoneDialCode: getUser?.result?.phoneDialCode,
                userStatus: getUser?.result?.userStatus,
                isBan: getUser?.result?.isBan,
                country: getUser?.result?.profile?.country,
                phoneCountryCode: getUser?.result?.phoneCountryCode,
                picture: getUser?.result?.profile?.picture,
                identityDocument: getUser?.result?.identityDocument,
                experienceDocument: getUser?.result?.experienceDocument,
                preferredCurrency: getUser?.result?.profile?.preferredCurrency,
                isRestrict
            }
        }

        if (!loading && !getUser?.result?.id) {
            return <NotFound title={formatMessage(messages.pageNotFound)} />;
        } else {
            return (
                <Loader type={"page"} show={loading}>
                    {!loading && !userCategoryLoding &&
                        <EditPartnerForm
                            getUser={getUser}
                            initialValues={initialValues}
                            profileId={this.props.id}
                            services={userCategoryDetails} />}
                </Loader>
            )
        }
    }
}

const mapState = state => ({});

const mapDispatch = {
    demoRestrictionEncode
};

export default compose(
    connect(mapState, mapDispatch),
    injectIntl,
    withQuery(getUser, {
        options: (props) => ({
            variables: {
                id: Number(props.id),
                userType: 2
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    }),
    withQuery(getUserCategoryQuery, {
        name: 'userCategoryDetails',
        options: (props) => ({
            variables: {
                profileId: Number(props.id)
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    })
)(EditPartner)
